import { configureStore, createListenerMiddleware } from "@reduxjs/toolkit";

import * as common from "#/redux/resource";
import * as govedo from "@/redux/resource";

const listenerMiddleware = createListenerMiddleware();

export const store = configureStore({
  /**
   * Importing all resources from common
   */
  reducer: {
    ...common,
    ...govedo,
  },

  // Add the listener middleware to the store.
  // NOTE: Since this can receive actions with functions inside,
  // it should go before the serializability check middleware
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().prepend(listenerMiddleware.middleware),
});
